import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgMagnifyingGlassPlus = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m20.725 19.559-4.711-4.711a7.12 7.12 0 0 0 1.613-4.536A7.31 7.31 0 0 0 10.315 3a7.313 7.313 0 0 0 0 14.625 7.27 7.27 0 0 0 4.535-1.583l4.711 4.71a.844.844 0 0 0 1.194 0 .82.82 0 0 0-.03-1.193m-10.41-3.622a5.63 5.63 0 0 1-5.625-5.624 5.63 5.63 0 0 1 5.625-5.626 5.63 5.63 0 0 1 5.625 5.626 5.63 5.63 0 0 1-5.625 5.624m2.812-6.468h-2V7.5c0-.466-.378-.844-.812-.844a.864.864 0 0 0-.844.844v1.969h-2c-.436 0-.812.376-.812.844s.377.843.812.843h2v1.969c0 .466.377.844.812.844.466 0 .812-.378.812-.844v-1.969h1.97c.53 0 .906-.376.906-.844a.84.84 0 0 0-.844-.843"
    }));
export default SvgMagnifyingGlassPlus;
